module.exports = fox._r("images/pic_preload.gif", __webpack_public_path__ + "_/_/_/root/images/pic_preload.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/pic_preload.gif
// module id = 1245
// module chunks = 4